<div class="main no-padding">
  <header-menu></header-menu>

  <div class="center-content internal-registration-establishment fade-in-animation">
    <div class="card area-to-overlay">
      <div class="card-content">

        <header>
          <h1>Cadastro do Negócio</h1>
        </header>

        <h2>Modalidade*</h2>
        <p>
          <label><input name="" [ngModel]="checkModality(1)" (click)="toggleKind(1)" type="checkbox" /> Minha empresa vende por meio da internet.</label><br />
          <label><input name="" [ngModel]="checkModality(2)" (click)="toggleKind(2)" type="checkbox" /> Minha empresa possui estabelecimentos físicos.</label><br />
          <label><input name="" [ngModel]="checkModality(3)" (click)="toggleKind(3)" type="checkbox" /> Minha empresa vai até o cliente.</label><br />
        </p>

        <h2>Informações gerais*</h2>
        <div class="responsive-columns">
          <div>
            <label>
              Nome do negócio<br />
              <input class="form-control" placeholder="Nome do Negócio" [(ngModel)]="establishment.name" />
            </label>
          </div>
          <div class="cnpj">
            <label>
              CNPJ<br />
              <input name="" class="form-control" placeholder="" [textMask]="{mask: cnpjMask}" value="{{ establishment?.cnpj }}" readonly />
            </label>
          </div>
        </div>
        <div class="responsive-columns">
          <div>
            <label>
              Categoria (o principal ramo de atividade do seu negócio)<br />
              <div *ngIf="categories.length > 0" class="form-group">
                <ng-select [(ngModel)]="establishment.categorySelected"
                           (ngModelChange)="changeCategory($event)"
                           placeholder="Selecione uma categoria"
                           [items]="categories">
                </ng-select>
              </div>
            </label>
          </div>
          <div></div>
        </div>
        <div id="internet" *ngIf="checkModality(1)">
          <h2>Como encontrar seu negócio na internet*</h2>
          <div class="responsive-columns">
            <div>
              <label>
                Site<br />
                <input name="" class="form-control" placeholder="Site do Negócio" [(ngModel)]="establishment['urls']['url_website']" />
              </label>
            </div>
            <div>
              <label>
                IOS - APP Store<br />
                <input name="" class="form-control" placeholder="Endereço da App Store" [(ngModel)]="establishment['urls']['url_ios']" />
              </label>
            </div>
          </div>
          <div class="responsive-columns">
            <div>
              <label>
                Android - Play Store<br />
                <input name="" class="form-control" placeholder="Endereço da Play Store" [(ngModel)]="establishment['urls']['url_android']" />
              </label>
            </div>
            <div>
              <label>
                Windows Phone Store<br />
                <input name="" class="form-control" placeholder="Endereço da Windows Phone Store" [(ngModel)]="establishment['urls']['url_win']" />
              </label>
            </div>
          </div>

          <h2>Locais de Atuação*</h2>
          <p>
            Informe se seu negócio atua em todo o Brasil ou somente em alguns estados.
          </p>

          <p>
            <label>
              <input type="checkbox" [ngModel]="selectedStates.length === 27" (click)="toggleAll()" name=""> Todo o Brasil
            </label>
          </p>

          <div class="brasilian-states responsive-columns">
            <div>
              <label *ngFor="let state of stateList"><input type="checkbox" (click)="toggleAttendanceLocation(state)" [ngModel]="checkState(state)" id="{{ state.value }}"> {{ state.name }}</label>
            </div>
          </div>
        </div>
        <div class="responsive-columns">
          <div class="buttons-actions-colab-form" *ngIf="!isLoading">
            <button class="btn btn-orange-contrast" (click)="updateEstablishment()">Salvar alterações</button>
          </div>
        </div>
        <div class="loading-overlay" *ngIf="isLoading">
          <div class="loader-wrp">
            <div class="loader"><span></span><span></span><span></span></div>
            <p> {{ 'LOADING' | translate }}</p>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>